import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import displayNames from '../displayNames';
import TextFormattingToggleButton from './textFormattingToggleButton';
import TextFormattingButtonWithDropDown from './textFormattingButtonWithDropDown';
import TextFormattingDropDown from './textFormattingDropDown';
import { UrlUnlinkBold as UrlUnlinkBoldIcon, UrlLinkBold as UrlLinkBoldIcon, Underline as UnderlineIcon, Italic as ItalicIcon, Bold as BoldIcon, TextColor as TextColorIcon, HighlightColor as HighlightColorIcon } from '../../icons';
var Bold = function Bold(_ref) {
  var dataHook = _ref.dataHook,
    value = _ref.value,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    tooltipContent = _ref.tooltipContent;
  var props = {
    dataHook: dataHook,
    value: value,
    onChange: onChange,
    disabled: disabled,
    tooltipContent: tooltipContent
  };
  return /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHook
  }, /*#__PURE__*/React.createElement(TextFormattingToggleButton, _extends({
    name: displayNames.TEXT_BOLD_BUTTON
  }, props), /*#__PURE__*/React.createElement(BoldIcon, null)));
};
Bold.displayName = displayNames.TEXT_BOLD_BUTTON;
var Italic = function Italic(_ref2) {
  var dataHook = _ref2.dataHook,
    value = _ref2.value,
    onChange = _ref2.onChange,
    disabled = _ref2.disabled,
    tooltipContent = _ref2.tooltipContent;
  var props = {
    dataHook: dataHook,
    value: value,
    onChange: onChange,
    disabled: disabled,
    tooltipContent: tooltipContent
  };
  return /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHook
  }, /*#__PURE__*/React.createElement(TextFormattingToggleButton, _extends({
    name: displayNames.TEXT_ITALIC_BUTTON
  }, props), /*#__PURE__*/React.createElement(ItalicIcon, null)));
};
Italic.displayName = displayNames.TEXT_ITALIC_BUTTON;
var Underline = function Underline(_ref3) {
  var dataHook = _ref3.dataHook,
    value = _ref3.value,
    onChange = _ref3.onChange,
    disabled = _ref3.disabled,
    tooltipContent = _ref3.tooltipContent;
  var props = {
    dataHook: dataHook,
    value: value,
    onChange: onChange,
    disabled: disabled,
    tooltipContent: tooltipContent
  };
  return /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHook
  }, /*#__PURE__*/React.createElement(TextFormattingToggleButton, _extends({
    name: displayNames.TEXT_UNDERLINE_BUTTON
  }, props), /*#__PURE__*/React.createElement(UnderlineIcon, null)));
};
Underline.displayName = displayNames.TEXT_UNDERLINE_BUTTON;
var Link = function Link(_ref4) {
  var dataHook = _ref4.dataHook,
    value = _ref4.value,
    _onChange = _ref4.onChange,
    disabled = _ref4.disabled,
    tooltipContent = _ref4.tooltipContent;
  var props = {
    dataHook: dataHook,
    hasBackgroundWhenSelected: true,
    options: [{
      value: false,
      content: /*#__PURE__*/React.createElement(UrlUnlinkBoldIcon, null),
      key: 'false'
    }, {
      value: true,
      content: /*#__PURE__*/React.createElement(UrlLinkBoldIcon, null),
      key: 'true'
    }],
    value: value,
    onChange: function onChange(newValue) {
      _onChange(newValue === 'true' ? true : false);
    },
    disabled: disabled,
    tooltipContent: tooltipContent
  };
  return /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHook
  }, /*#__PURE__*/React.createElement(TextFormattingButtonWithDropDown, _extends({
    name: displayNames.TEXT_LINK_BUTTON
  }, props), /*#__PURE__*/React.createElement(UrlLinkBoldIcon, null)));
};
Link.displayName = displayNames.TEXT_LINK_BUTTON;
var Color = function Color(_ref5) {
  var dataHook = _ref5.dataHook,
    value = _ref5.value,
    onChange = _ref5.onChange,
    disabled = _ref5.disabled,
    tooltipContent = _ref5.tooltipContent;
  var props = {
    dataHook: dataHook,
    value: value,
    onChange: onChange,
    disabled: disabled,
    tooltipContent: tooltipContent
  };
  return /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHook
  }, /*#__PURE__*/React.createElement(TextFormattingToggleButton, _extends({
    name: displayNames.TEXT_COLOR_BUTTON
  }, props), /*#__PURE__*/React.createElement(TextColorIcon, null)));
};
Color.displayName = displayNames.TEXT_COLOR_BUTTON;
var Highlight = function Highlight(_ref6) {
  var dataHook = _ref6.dataHook,
    value = _ref6.value,
    onChange = _ref6.onChange,
    disabled = _ref6.disabled,
    tooltipContent = _ref6.tooltipContent;
  var props = {
    dataHook: dataHook,
    value: value,
    onChange: onChange,
    disabled: disabled,
    tooltipContent: tooltipContent
  };
  return /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHook
  }, /*#__PURE__*/React.createElement(TextFormattingToggleButton, _extends({
    name: displayNames.TEXT_HIGHLIGHT_BUTTON
  }, props), /*#__PURE__*/React.createElement(HighlightColorIcon, null)));
};
Highlight.displayName = displayNames.TEXT_HIGHLIGHT_BUTTON;
var Custom = function Custom(_ref7) {
  var dataHook = _ref7.dataHook,
    value = _ref7.value,
    onChange = _ref7.onChange,
    disabled = _ref7.disabled,
    tooltipContent = _ref7.tooltipContent,
    Icon = _ref7.icon,
    options = _ref7.options,
    shouldTranslate = _ref7.shouldTranslate;
  var props = {
    dataHook: dataHook,
    value: value,
    onChange: onChange,
    disabled: disabled,
    tooltipContent: tooltipContent,
    options: options,
    shouldTranslate: shouldTranslate,
    name: displayNames.TEXT_CUSTOM_BUTTON
  };
  return /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHook
  }, options ? /*#__PURE__*/React.createElement(TextFormattingDropDown, props) : /*#__PURE__*/React.createElement(TextFormattingToggleButton, props, /*#__PURE__*/React.createElement(Icon, null)));
};
Custom.displayName = displayNames.TEXT_CUSTOM_BUTTON;
export default {
  bold: Bold,
  italic: Italic,
  underline: Underline,
  link: Link,
  color: Color,
  highlight: Highlight,
  custom: Custom
};